export default {
  "red-blue": {
    text: ["R", "B"],
    colors: ["#FF1111", "#1111FF"],
  },
  yellow: {
    text: ["Y"],
    colors: ["#FFD733"],
  },
  "gold-silver": {
    text: ["G", "S"],
    colors: ["#DAA520", "#C0C0C0"],
  },
  crystal: {
    text: ["C"],
    colors: ["#4FD9FF"],
  },
  "ruby-sapphire": {
    text: ["RU", "SA"],
    colors: ["#A00000", "#0000A0"],
  },
  emerald: {
    text: ["E"],
    colors: ["#00A000"],
  },
  "firered-leafgreen": {
    text: ["FR", "LG"],
    colors: ["#FF7327", "#00DD00"],
  },
  "diamond-pearl": {
    text: ["D", "P"],
    colors: ["#AAAAFF", "#FFAAAA"],
  },
  platinum: {
    text: ["PL"],
    colors: ["#999999"],
  },
  "heartgold-soulsilver": {
    text: ["HG", "SS"],
    colors: ["#B69E00", "#C0C0E1"],
  },
  "black-white": {
    text: ["B", "W"],
    colors: ["#444444", "#E1E1E1"],
  },
  "black-2-white-2": {
    text: ["B2", "W2"],
    colors: ["#424B50", "#E3CED0"],
  },
  "x-y": {
    text: ["X", "Y"],
    colors: ["#025DA6", "#EA1A3E"],
  },
  "omega-ruby-alpha-sapphire": {
    text: ["OR", "AS"],
    colors: ["#AB2813", "#26649C"],
  },
  "sun-moon": {
    text: ["SN", "MN"],
    colors: ["#F1912B", "#5599CA"],
  },
  "ultra-sun-ultra-moon": {
    text: ["US", "UM"],
    colors: ["#E95B2B", "#226DB5"],
  },
};
